import React, { useEffect, useState } from 'react'
import AddLayout from '../../../../component/AddLayout'
import { Autocomplete, Box, Button, OutlinedInput, TextField } from '@mui/material'
import DatePicker from '../../../../component/DatePicker'
import dayjs from 'dayjs'
import RequireField from '../../../../component/RequireField'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { CalQtySack, GetBreedClassNo, GetSeasonNo, StockStatus } from '../../services/stockService';
import { detailReceives, getItemMasterList, getLatestLot, updateReceives } from '../../services/api'
import ConfirmDialogReceive from '../../component/confirmDialogReceive'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import PintButton from '../../../../component/PintButton'
import ConfirmPrint from '../../component/confirmPrint'
import { downloadPDF } from '../../../../component/downloadPDF'
export default function StockReceiveDetail() {
    const { profile } = useSelector(state => state.profile)
    const navigate = useNavigate();
    const { id } = useParams()
    const location = useLocation();
    const [openP, setOpenP] = useState(false);
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [detail, setDetail] = useState()
    const [createId, setCreateId] = useState()
    const [modifiedId, setModifiedId] = useState()
    const [receiveDate, setReceiveDate] = useState(dayjs(new Date()))
    const [refNo, setRefNo] = useState('')
    const [refNoError, setRefNoError] = useState(false)
    const [remark, setRemark] = useState('')
    const [items, setItems] = useState([])
    const [lastLot, setLastLot] = useState()
    const [open, setOpen] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);

    const [rows, setRows] = useState([
        {
            id: 0,
            ItemName: "",
            Year: '',
            Season: "",
            Lot: "",
            Qty: '',
            UnitNo: "",
            ModifiedDate: null,
            WarehouseNo: "",
            ZoneNo: "",
            SalePrice: 0,
            CostPrice: 0,
            ItemNo: null
        }
    ]);

    const getLastLot = async (prefix) => {
        const data = await getLatestLot(prefix)
        setLastLot(data)
    }
    const getDetailReceives = async () => {
        const data = await detailReceives(id)
        if (data) {
            setDetail(data)
            setReceiveDate(dayjs(data?.ReceiveDate))
            setRefNo(data?.RefNo)
            setRemark(data?.Remark)
            setCreateId(data?.CreateId)
            setModifiedId(data?.ModifiedId)
            setRows(data?.ReceiveDetails)
        }

    }

    useEffect(() => {
        if (location?.state?.new) {
            setOpenP(true)
        }
    }, [location?.state?.new])
    useEffect(() => {
        const getItemList = async () => {
            const data = await getItemMasterList()
            setItems(data)
        }
        getItemList()

        getDetailReceives()

    }, [])

    const receiveAdd = async (body) => {
        setLoadingSubmit(true)
        const put = async () => {
            const res = await updateReceives(body)
            if (res) {
                if (body.Status === 'N') {
                    Swal.fire(
                        'ยกเลิกรายการสำเร็จ',
                        '',
                        'success'
                    ) 
                    getDetailReceives()
                    setLoadingSubmit(false)
                }else {
                    setLoadingSubmit(false)
                    setOpen(false)
                    setOpenP(true)
                    getDetailReceives()
                }
                
            } else {
                Swal.fire({
                    title: 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
                setLoadingSubmit(false)
            }
        }
        put()

    }

    const handleSubmit = (e) => {
        if(e === 'N') {
          return  Swal.fire({
                title: 'ยืนยันการยกเลิก',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#4ab866',
                cancelButtonColor: '#d33',
            }).then((result) => {
                if (result.isConfirmed) {
                    handleAdd('N')
                }
            })
        }

        if (!refNo) {
            setRefNoError(true)
        }
        if (rows?.filter((x) => !x?.ItemNo)) {
            const item = rows?.map((v, index) => {
                v.LotError = v.ItemNo ? false : true
                return v;

            });
            setRows([...item]);
        }
        if (rows?.filter((x) => x?.Year?.length < 1)) {
            const item = rows?.map((v, index) => {
                v.YearError = v?.Year?.length >= 1 ? false : true
                return v;

            });
            setRows([...item]);
        }

        if (rows?.filter((x) => x?.Lot?.length < 3)) {
            const item = rows?.map((v, index) => {
                v.LotGenError = v.Lot?.length >= 3 ? false : true
                return v;

            });
            setRows([...item]);
        }
        if (rows?.filter((x) => x?.WarehouseNo?.length < 1)) {
            const item = rows?.map((v, index) => {
                v.WarehouseError = v.WarehouseNo ? false : true
                return v;

            });
            setRows([...item]);
        }
        if (refNo && rows?.filter((x) => !x?.ItemNo).length === 0 && rows?.filter((x) => x?.Year?.length < 1).length === 0 && rows?.filter((x) => x?.Lot?.length < 3).length === 0 && rows?.filter((x) => x?.WarehouseNo?.length < 1).length === 0) {
            setOpen(true)
        }
    }
    const handleAdd = (e) => {

        const body = {
            ReceiveNo: id,
            BranchNo: profile?.BranchNo?.BranchNo,
            RefNo: refNo,
            DocumentDate: dayjs(new Date()).format('YYYY-MM-DD'),
            ReceiveDate: dayjs(receiveDate).format('YYYY-MM-DD'),
            Remark: remark,
            Status: e || 'Y',
            ReceiveDetails: rows?.map((x) => (
                {
                    ...x,
                    ItemNo: x?.ItemNo?.ItemNo,
                    UnitNo: x?.UnitNo?.UnitNo,
                    ModifiedDate: dayjs(new Date()).format('YYYY-MM-DD'),
                    WarehouseNo: x?.WarehouseNo?.WarehouseNo,
                    ZoneNo: x?.ZoneNo?.ZoneNo,
                    CostPrice: +x?.CostPrice
                }
            ))
        }

        receiveAdd(body)

    }
    async function downloadReceive() {
        const url = `stock/receives/${id}/pdf`
        downloadPDF(setLoadingPDF, url)
    }
    const inputHead = [
        {
            name: 'วันรับเมล็ดพันธุ์เข้าคลัง',
            inputComponent: <><DatePicker value={receiveDate} onChange={e => setReceiveDate(e)} disabled={true} /></>,
        },
        {
            name: 'เลขที่อ้างอิง',
            inputComponent: <>
                <RequireField value={refNo} onChange={setRefNo} type={'text'} disabled={true} error={refNoError} setError={setRefNoError} textError={'กรุณากรอกเลขที่อ้างอิง'} />
            </>,
        },
        {
            name: <><label class="labelInput">ผู้สร้าง</label><label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/YYYY')} )</label>  </>,
            inputComponent: <>
                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                    <TextField value={createId} variant="standard" fullWidth disabled={id ? true : false}
                        InputProps={{
                            disableUnderline: true,
                            readOnly: true
                        }}
                    />
                </Box>
            </>,
        },
        {
            name: <><label class="labelInput">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/YYYY')} )</label></>,
            inputComponent: <>
                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                    <TextField value={modifiedId} variant="standard" fullWidth disabled={id ? true : false}
                        InputProps={{
                            disableUnderline: true,
                            readOnly: true
                        }}
                    />
                </Box>
            </>,
        },
    ]
    const head = [
        'ที่',
        'เมล็ดพันธุ์',
        'ชั้นพันธุ์',
        'ฤดู',
        'กลุ่มพันธุ์',
        'สารเคมี',
        'ปีที่ผลิต',
        'ล็อตที่',
        'จำนวน (กระสอบ)',
        'ปริมาณ',
        'หน่วย',
        'โรงเก็บที่',
        'ราคาจำหน่าย',
        'ต้นทุนการผลิต',
        ''
    ]
    const body = rows?.map((x, i) => {
        return {
            item1: i + 1,
            item2: <><Autocomplete
                size='small'
                readOnly={true}
                options={items}
                getOptionLabel={(option) => option?.ItemName}
                onBlur={e => {
                    const item = rows?.map((v, index) => {
                        v.LotError = index === i ? x.ItemNo ? false : true : v?.LotError;
                        return v;
                    });
                    setRows([...item]);
                }
                }
                componentsProps={{
                    paper: {
                        sx: {
                            width: 500
                        }
                    }
                }}
                renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.ItemNo}>
                        {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1} {option?.Chemical}
                    </Box>
                )}
                value={x?.ItemNo}
                onChange={(event, newValue) => {
                    const item = rows?.map((v, index) => {
                        v.LotGen = index === i ? null : v?.LotGen;
                        v.ItemNo = index === i ? newValue : v?.ItemNo;
                        v.Year = index === i ? '' : v?.Year;
                        v.Lot = index === i ? '' : v?.Lot;

                        return v;

                    });
                    setRows([...item]);

                }}

                renderInput={(params) => (
                    <Box ref={params.InputProps.ref}>
                        <OutlinedInput error={!x?.LotError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: '#e9ecef' }} />
                    </Box>
                )}
            />
                {!x?.LotError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: '8px' }}>กรุณาเลือกเมล็ดพันธุ์</span>}</>,
            item3: x?.ItemNo?.Option2,
            item4: <span style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}</span>,
            item5: x?.ItemNo?.Option1,
            item6: x?.ItemNo?.Chemical,
            item7: <>
                <TextField className='w-70'
                    value={x?.Year || ''}
                    size='small' variant='outlined' onChange={e => {
                        const branchNo = profile?.BranchNo?.BranchNo
                        const breedClassNo = GetBreedClassNo(x?.ItemNo?.Option2)
                        const seasonNo = GetSeasonNo(x?.ItemNo?.Season)
                        const lotNumber = branchNo + breedClassNo + seasonNo + e.target.value;
                        const item = rows?.map((v, index) => {
                            v.Year = index === i ? e.target.value : v?.Year;
                            v.LotGen = index === i ? lotNumber : v?.LotGen
                            return v;

                        });
                        setRows([...item]);
                        getLastLot(x?.LotGen)
                    }}
                    InputProps={{
                        disableUnderline: true,
                        readOnly: true
                    }}
                    sx={{ background: '#e9ecef' }}
                    inputProps={{ maxLength: 2 }}
                    onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }} />
            </>,
            item8: <>
                <Box sx={{
                    display: 'flex', '& .MuiTextField-root': {
                        color: 'red',
                        '& .MuiOutlinedInput-root': { borderRadius: '0 .25rem .25rem 0' }
                    }
                }}>
                    <TextField
                        InputProps={{
                            disableUnderline: true,
                            readOnly: true
                        }}
                        sx={{ width: '150px', background: '#e9ecef' }} error={!x?.LotGenError ? false : true}
                        value={x?.Lot || ''}
                        inputProps={{ maxLength: 3 }}
                        size='small' fullWidth variant='outlined' onChange={e => {
                            const item = rows?.map((v, index) => {
                                v.Lot = index === i ? e.target.value : v?.Lot;
                                return v;

                            });
                            setRows([...item]);
                        }} onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }} />

                </Box>

            </>,
            item9: CalQtySack(x?.ItemNo?.Option2, +x.Qty.toString().replaceAll(',', '')),
            item10: <TextField value={x?.Qty.toLocaleString()}
                InputProps={{
                    disableUnderline: true,
                    readOnly: true
                }} sx={{ background: '#e9ecef', width: '120px' }}
                type='tel' size='small' fullWidth variant='outlined' onChange={e => {
                    let newValue = e.target.value.replace(/,/g, "");

                    let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    const item = rows?.map((v, index) => {
                        v.Qty = i === index ? abc : v?.Qty;
                        return v;

                    });
                    setRows([...item]);
                }} onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                    }
                }} />,
            item11: x?.UnitNo?.UnitName,
            item12: <>
                <TextField sx={{ background: id ? '#e9ecef' : '#fff', width: '120px' }} InputProps={{
                    readOnly: id ? true : false
                }} value={x?.WarehouseNo.BranchNo === profile?.BranchNo?.BranchNo ? `${x?.WarehouseNo?.WarehouseName} ${x?.ZoneNo?.ZoneName}` : ''} size='small' fullWidth variant='outlined' />
            </>,
            item13: x?.ItemNo?.SalePrice,
            item14:
                <TextField sx={{ width: '150px' }} type='number' value={x?.CostPrice} size='small' fullWidth variant='outlined' onChange={e => {

                    const item = rows?.map((v, index) => {
                        v.CostPrice = i === index ? e.target.value : v?.CostPrice;
                        return v;

                    });
                    setRows([...item]);
                }} />,
            item15: <></>
        }
    })
    return (
        <AddLayout
            title={'ข้อมูลรับเมล็ดพันธุ์ดี'}
            action={<PintButton loading={loadingPDF} download={downloadReceive} />}
            inputHead={inputHead}
            inputRemark={
                <div class="col-lg-10 col-md-12">
                    <label class="labelInput">หมายเหตุ</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px', borderRadius: '25px' }}>
                        <TextField value={remark} onChange={e => setRemark(e.target.value)} variant="standard" fullWidth multiline rows={3} disabled={true}
                            InputProps={{
                                disableUnderline: true,
                            }}

                        />
                    </Box>
                </div>}
            bodyTitle={'รายการรับเมล็ดพันธุ์ดี'}
            bodyAction={null}
            tableHead={head}
            tableBody={body}
            bootomAction={<>
                <Button onClick={() => navigate(location?.state?.new ? -2 : -1)} variant='outlined'
                    startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                    sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                {detail?.Status !== 'N' ? <Button variant='contained' onClick={() => handleSubmit(StockStatus?.Active)} sx={{ width: '130px', fontSize: '14px' }}>{'เเก้ไข'}</Button> : null}
                {detail?.Status !== 'N' &&
                    detail?.Cancelable ?
                    <Button variant='contained' onClick={() => handleSubmit(StockStatus?.Inactive)} color='error' type='submit' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }}>ยกเลิก</Button> : null}
            </>}
            dialog={<>
                <ConfirmDialogReceive open={open} setOpen={setOpen} rows={rows} handleAdd={handleAdd} loadingSubmit={loadingSubmit} />
                <ConfirmPrint title={'บันทึกรายการรับเมล็ดพันธุ์สำเร็จ'} download={downloadReceive} open={openP} setOpen={setOpenP} loadingPDF={loadingPDF} linkTo='/stock/stock-receive/add' />
            </>} />
    )
}
